import { css } from 'styled-components';

export const shadows = {
	base: css`
		box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.3);
	`
};
